// extracted by mini-css-extract-plugin
export default {"bgVid":"Header_bgVid__Ge-RY","rowHeader":"Header_rowHeader__BTUYF","contentStory":"Header_contentStory__t6gDa","headerImage":"Header_headerImage__vmZ6X","img":"Header_img__gSJBG"};